import React from 'react';
import { PageContainer } from '@ant-design/pro-layout';
import { Button, Space } from 'antd';
import { useMutation, useQuery } from '@apollo/client';
import { ProTable, Link } from '../../layout';
import {
  GET_BUDGET_CATEGORIES,
  TOGGLE_DISABLED_BUDGET_CATEGORY,
} from '../../../gql/budgetCategories';
import { EditButton, DisabledButton } from 'components/button';
import { useLoading } from 'hooks';

const BudgetCategories = () => {
  const { data, loading } = useQuery(GET_BUDGET_CATEGORIES, {
    variables: { state: 'ALL' },
  });
  const [
    toggleDisabledBudgetCategory,
    { loading: disableLoading },
  ] = useMutation(TOGGLE_DISABLED_BUDGET_CATEGORY, {
    refetchQueries: ({
      data: {
        toggleDisabledBudgetCategory: { id },
      },
    }) => [
      { query: GET_BUDGET_CATEGORIES, variables: { ids: [id], state: 'ALL' } },
      { query: GET_BUDGET_CATEGORIES },
    ],
    onError: (err) => {
      console.log(err);
    },
  });
  useLoading(disableLoading);

  const columns = [
    {
      title: 'Seq',
      dataIndex: 'seq',
      defaultSortOrder: 'ascend',
      sorter: (a, b) => a.seq - b.seq,
      width: 72,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      width: '15%',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      ellipsis: true,
    },
    {
      title: 'Status',
      dataIndex: 'disabled',
      width: 120,
      filters: true,
      onFilter: true,
      valueEnum: {
        false: { text: 'Running', status: 'Success' },
        true: { text: 'Stop', status: 'Error' },
      },
    },
    {
      title: 'Actions',
      width: 200,
      render: (_, item) => (
        <Space size={0}>
          <Link to={`/system-setting/budget-categories/${item.id}`}>
            <EditButton />
          </Link>
          <DisabledButton
            disabled={item.disabled}
            onClick={() => {
              toggleDisabledBudgetCategory({ variables: { id: item.id } });
            }}
          />
        </Space>
      ),
    },
  ];

  return (
    <PageContainer
      loading={loading}
      header={{
        title: 'Budget Categories',
        extra: [
          <Button type="primary" key="add">
            <Link to="/system-setting/budget-categories/add">Add</Link>
          </Button>,
        ],
      }}
    >
      <ProTable
        loading={loading}
        toolbar={{
          settings: false,
        }}
        toolBarRender={false}
        columns={columns}
        rowKey="id"
        search={false}
        dataSource={data?.budgetCategories}
        pagination={false}
      />
    </PageContainer>
  );
};

export default BudgetCategories;
